/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(StringResources, APIFactory, ContentActionsProviderAPI) {

	class LassoSelectAction {
		constructor({ features }) {
			if(features) {
				this.dashboard = features.API;
				this.icons = features.Icons;
				features.ContentActions.registerProvider('lasso', this.getAPI());
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}

		destroy () {
			this.dashboard = null;
		}

		getContentActionList(idList) {
			if (this._supportAction(idList) && this.content) {
				const visualizationGesture = this.content.getFeature('VisualizationGesture');
				const marqueeIcon = this.icons.getIcon('visualizations-marquee_16');

				return [{
					id: 'lasso-select-toolbar-id',
					name: 'lasso',
					label: StringResources.get('toolbarActionLassoSelect'),
					icon: marqueeIcon.id,
					type: 'Button',
					selected: visualizationGesture ? visualizationGesture.getLassoSelectState() : false,
					actions: {
						apply: this._toggleLassoSelect.bind(this)
					}
				}];
			}
			return [];
		}

		_supportAction(idList) {
			if (!this._isInteractionEnabled('lassoSelect')) {
				return false;
			}
			if (idList.length !== 1) {
				return false;
			}
			if (this.dashboard.getMode() === this.dashboard.MODES.EDIT_GROUP) {
				return false;
			}

			this.content = this.dashboard.getCanvas().getContent(idList[0]);
			if (!this.content) {
				return false;
			}

			const visualization = this.content.getFeature('Visualization');
			if (!visualization || visualization.getDefinition().getState().getError() ||
			!visualization.getSlots().isMappingComplete()) {
				return false;
			}

			const state = this.content.getFeature('state');
			const hasError = Boolean(state && !!state.getError());
			if (hasError) {
				return false;
			}

			return this.content.getType() === 'widget.live'
				&& this._isSupportedVisualizationType(visualization.getType())
				&& !visualization.getDefinition().getProperty('isSchematic')
				&& !visualization.getDefinition().getProperty('isCustomVis');
		}

		_isSupportedVisualizationType(type) {
			const visDefsNoLassoSelect = [
				'Singleton',
				'DataPlayer',
				'Crosstab',
				'List',
				'Hierarchy',
				'KPI',
				'Pie',
				'Wordle',
				'Area',
				'Dial',
				'Bullet',
				'DecisionTree',
				'Sunburst',
				'Spiral',
				'DriverAnalysis',
				'visualizationPreview',
				'snippetList'
			];

			return !visDefsNoLassoSelect.includes(type);
		}

		/**
		 * Check whether a particular interaction is enabled.
		 * Perspective drives this config.
		 *
		 * @param {string} name - interaction name
		 *
		 * @return {boolean} TRUE if interaction is enabled and FALSE if not
		 */
		_isInteractionEnabled(name) {
			const config = this._getInteractionConfig();
			if (config.hasOwnProperty(name) && [false, 'false'].indexOf(config[name]) !== -1) {
				return false;
			}
			return true;
		}

		_getInteractionConfig() {
			return this.dashboard.getAppConfig('interactions') || {};
		}

		/**
		* Action invoked to toggle laaso selection on a viz
		*/
		_toggleLassoSelect(event) {
			const visualizationGesture = this.content.getFeature('VisualizationGesture');

			if (visualizationGesture) {
				const lassoState = visualizationGesture.getLassoSelectState();
				visualizationGesture.setLassoSelectState(!lassoState);
				const $toolBarItem = event && event.currentTarget;
				if ($toolBarItem) {
					if(lassoState) {
						$toolBarItem.classList.remove('selected');
					} else {
						$toolBarItem.classList.add('selected');
					}
				}
			}
		}
	}
	return LassoSelectAction;
});
